export default __webpack_public_path__ + "static/prod2-961e5ab9e04c689e23167eafa62ddb3e.jpg";